import React from 'react';

class EditSectionLabel extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      Text: this.props.Text === undefined ? '' : this.props.Text,
      className: this.props.className === undefined ? '' : this.props.className,
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){

    this.setState( {
      Text: nextProps.Text,
      className: nextProps.className === undefined ? '' : nextProps.className
    } );
  }

  render(){

    const hilite = this.props.hilite === undefined ? false: true;
    const disabled = this.props.disabled === undefined ? false : this.props.disabled;
    const height = this.props.height === undefined ? 'auto' : this.props.height;
    const width = this.props.width === undefined ? 'auto' : this.props.width;
    const textAlign = this.props.textAlign === undefined ? 'left' : this.props.textAlign;
    const visible = this.props.visible === undefined ? true : this.props.visible;
    const Text = this.props.Text === undefined ? '' : this.props.Text;
    let readonly = this.props.readonly === undefined ? false : true;
    const className = 'edit-section-label ' + this.state.className;

    var styles = {
      'display': width === 'auto' ? 'inline' : 'inline-block',
      'height': height,
      'width': width,
      'fontSize': '100%',
      'fontWeight': hilite === true ? 'bold' : 'inherit',
      'color': hilite === true ? 'black' : 'inherit',
      'textAlign': textAlign,
    };

    let opts = {};

    if( readonly === true ) {
      opts['readonly'] = 'readonly';
    }

    if( ( visible === false ) || ( this.state.hasError === true ) ) {
      return(
        <span></span>
      );
    } else {

      return (
        <span className={className} style={styles} disabled={disabled}>{Text}</span>
      );
    }
  }
}

export default EditSectionLabel;



// WEBPACK FOOTER //
// ./src/presentation/EditSectionLabel.js